import React from 'react';
import { useTranslation } from 'react-i18next';
import type { RadarItem } from '@/services/predictiveCalendarService';

interface RadarCardProps {
  item: RadarItem;
  onGenerateDraft: (item: RadarItem) => void;
}

export const RadarCard: React.FC<RadarCardProps> = ({ item, onGenerateDraft }) => {
  const { t } = useTranslation(['common', 'strategist']);
  const getUrgencyBadge = () => {
  // F-411 (familia): o codemod de i18n tinha colado um useTranslation()
  // DENTRO desta funcao — hook fora do ciclo de render, "Invalid hook
  // call" a cada chamada. Era por isso que toasts/acoes daqui morriam em
  // silencio. O `t` nem era usado.
    switch (item.urgencia) {
      case 'no_horizonte':
      case 'preparar':
        return (
          <span style={{
            fontSize: '11px',
            fontWeight: 700,
            padding: '3px 8px',
            borderRadius: '12px',
            backgroundColor: 'rgba(37, 99, 235, 0.15)',
            color: 'var(--nexus-brand)',
            border: '1px solid rgba(59, 130, 246, 0.3)'
          }}>
            Antecipar {item.lead_time_dias ? `(D-${item.lead_time_dias})` : ''}
          </span>
        );
      case 'imediata':
        return (
          <span style={{
            fontSize: '11px',
            fontWeight: 700,
            padding: '3px 8px',
            borderRadius: '12px',
            backgroundColor: 'rgba(239, 68, 68, 0.15)',
            color: 'var(--sig-crit)',
            border: '1px solid rgba(239, 68, 68, 0.3)'
          }}>
            Pico Imediato (D-{item.lead_time_dias})
          </span>
        );
      default:
        return (
          <span style={{
            fontSize: '11px',
            fontWeight: 700,
            padding: '3px 8px',
            borderRadius: '12px',
            backgroundColor: 'rgba(16, 185, 129, 0.15)',
            color: 'var(--sig-ok)',
            border: '1px solid rgba(16, 185, 129, 0.3)'
          }}>
            {`${t('strategist:calendar.open_window', 'Janela Aberta')}`} (D-{item.lead_time_dias})
          </span>
        );
    }
  };

  return (
    <div
      style={{
        backgroundColor: 'var(--bg-1, #1E293B)',
        border: '1px solid var(--border-1, #334155)',
        borderRadius: '8px',
        padding: '16px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        transition: 'transform 0.15s ease, border-color 0.15s ease',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}
    >
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '10px' }}>
          <span style={{ fontSize: '11px', color: 'var(--text-3, #94A3B8)', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: 600 }}>
            {item.categoria}
          </span>
          {getUrgencyBadge()}
        </div>

        <h3 style={{ fontSize: '15px', fontWeight: 700, color: 'var(--text-1, #F8FAFC)', margin: '0 0 8px 0', lineHeight: 1.3 }}>
          {item.termo}
        </h3>

        <div style={{ fontSize: '12px', color: 'var(--text-2, #CBD5E1)', marginBottom: '12px', lineHeight: 1.4 }}>
          {item.pautas_chave ? (
            <div style={{ marginBottom: '6px' }}><strong>Pautas:</strong> {item.pautas_chave}</div>
          ) : item.estrategia ? (
            <div style={{ marginBottom: '6px' }}><strong>Estratégia:</strong> {item.estrategia}</div>
          ) : (
            <div style={{ marginBottom: '6px' }}>
              <strong>Horizonte:</strong> {item.horizonte} • <strong>Lead Time:</strong> {item.lead_time_semanas} semanas ({item.lead_time_dias} dias)
            </div>
          )}
        </div>
      </div>

      <div style={{ borderTop: '1px solid var(--border-2, rgba(255,255,255,0.08))', paddingTop: '12px', marginTop: '8px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '11.5px', color: 'var(--sig-warn)', marginBottom: '12px' }}>
          <span></span>
          <span style={{ fontWeight: 600 }}>{item.monetizacao_sugerida}</span>
        </div>

        <button
          onClick={() => onGenerateDraft(item)}
          style={{
            width: '100%',
            backgroundColor: 'var(--nexus-brand-active)',
            color: 'var(--text-1)',
            border: 'none',
            borderRadius: '6px',
            padding: '9px 12px',
            fontSize: '12.5px',
            fontWeight: 600,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '6px',
            transition: 'background-color 0.15s ease'
          }}
          onMouseOver={(e) => (e.currentTarget.style.backgroundColor = 'var(--nexus-brand-active)')}
          onMouseOut={(e) => (e.currentTarget.style.backgroundColor = 'var(--nexus-brand-active)')}
        >
          <span></span>
          <span>Gerar Rascunho com Afiliados</span>
        </button>
      </div>
    </div>
  );
};
